import React from 'react';
import { EmptyState, MobileCardRowsProps, MobileTable, Pagination, palette, Paper } from '@dev/ee-components';
import { useTranslation } from 'react-i18next';
import { isEmpty } from 'lodash-es';
import { useDispatch } from 'react-redux';
import { replace } from 'redux-first-history';

import { DEFAULT_ACTIVE_PAGE, DEFAULT_PER_PAGE_COUNT } from '@/services/constants';
import { addParamToUrl } from '@/services/tools/handleUrlParams';
import { useContactsCount } from '@/components/Contacts/Group/hooks';

import { MobileTableWrapper } from '../../../StyledComponents';
import { useHeadersOfContactsListTable, useRowsOfContactsListTable, useTableMenuActions } from '../../hooks';
import { ContactTableI } from '../../Interface';
import { useDefaultContactActionMenuOptions } from '../../hooks';

export const MobileContactTable = ({
    openSingleContactOverlay,
    perPage = DEFAULT_PER_PAGE_COUNT,
    activePage = DEFAULT_ACTIVE_PAGE,
}: ContactTableI): JSX.Element => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const headers = useHeadersOfContactsListTable();
    const rows = useRowsOfContactsListTable();
    const dropdownActions = useDefaultContactActionMenuOptions();
    const { tableMenuActions } = useTableMenuActions();
    const countOfSelectedContacts = useContactsCount();
    if (isEmpty(rows)) {
        return (
            <Paper style={{ padding: '32px 0', marginTop: '32px', boxShadow: '0px 0px 1px #2D37481A' }}>
                <EmptyState background={palette.basic.paper} text={t('thereisnodatatodisplay')} />
            </Paper>
        );
    }

    const handleMenuItemClick = (ev, option: Record<string, string>, email: string) => {
        tableMenuActions(option?.value, email);
    };

    const handleButtonClick = (e, contact) => {
        openSingleContactOverlay(contact?.id);
    };

    const changePagination = (page: number, perPage: number) => {
        const search = addParamToUrl({ page, perPage });
        dispatch(replace({ search }));
    };

    return (
        <>
            <MobileTableWrapper>
                <MobileTable
                    rows={rows as MobileCardRowsProps[]}
                    headers={headers as string[]}
                    onClickButton={handleButtonClick}
                    dropdownData={dropdownActions}
                    onItemClick={handleMenuItemClick}
                    disableSimplePopover={isEmpty(dropdownActions)}
                />
            </MobileTableWrapper>

            <Paper>
                <Pagination
                    perPage={perPage}
                    dataLength={countOfSelectedContacts || 0}
                    activePage={activePage}
                    handlePaginationChange={changePagination}
                    disableBorderTop
                />
            </Paper>
        </>
    );
};
